import { get } from '../../../lib/http'
import PageState from '../../../types/pageState'
import { storagePage } from '../storage'
import { CashboxUserData, DenominationMoneyData } from '../types'

export default async function loadMain(cashboxId: number) {
    const [result2, result3] = await Promise.all([
        get<CashboxUserData>(`/api/cashbox_users/cash_box_user/${cashboxId}`),
        get<DenominationMoneyData[]>('/api/cash_counts/denomination_money')
    ])

    if (result2.error || result3.error) {
        return PageState.ERROR
    }

    storagePage.cashboxUser = result2.data.result

    storagePage.isYourBox =
        storagePage.openedCashboxId === cashboxId ? true : false

    storagePage.userSessionHaveOpenBox = storagePage.openedCashboxId !== null
    storagePage.denominationMoneys = result3.data.result

    return PageState.SUCCESS
}
